import { render } from "./ocr_document_reader.html?vue&type=template&id=112c2d07&external"
import script from "./ocr_document_reader.js?vue&type=script&lang=js&external"
export * from "./ocr_document_reader.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__